abstract class VehicleDetailsFooter {
    abstract renderFooter(): JSX.Element;
}

export default VehicleDetailsFooter;
